import React, { useState } from "react";
import QrScanner from "react-qr-scanner";

const QrCodePage = () => {
  const [scanResult1, setScanResult1] = useState("");
  const [scanResult2, setScanResult2] = useState("");
  const [isScannerActive, setIsScannerActive] = useState(false);
  const [activeInput, setActiveInput] = useState(null); // Untuk melacak input mana yang sedang aktif

  const handleScan = (data) => {
    if (data) {
      if (activeInput === 1) {
        setScanResult1(data.text);
      } else if (activeInput === 2) {
        setScanResult2(data.text);
      }
      setIsScannerActive(false); // Menonaktifkan kamera setelah scan selesai
    }
  };

  const handleError = (err) => {
    console.error("Error with QR scanner: ", err);
  };

  const handleActivateScanner = (inputNumber) => {
    setActiveInput(inputNumber); // Menandai input mana yang akan diisi
    setIsScannerActive(true); // Mengaktifkan kamera
  };

  const previewStyle = {
    height: 240,
    width: "100%",
  };

  return (
    <>
      <div className="container" style={{ minHeight: "100vh" }}>
        <div className="row">
          <div className="col">
            <div className="card" style={{ minHeight: "100vh" }}>
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    {/* <div className="container-fluid"> */}
                    <h2 className="text-center">Monitoring Local</h2>

                    <div className="form-group mb-3">
                      <label className="text-uppercase font-weight-bold">Nomor OL</label>
                      <div className="row">
                        <div className="col">
                          <input type="text" placeholder="Nomor OL" className="form-control form-control-user" />
                        </div>
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="text-uppercase font-weight-bold">Status Proses Produksi</label>
                      <div className="row">
                        <div className="col">
                          <input type="text" placeholder="Status Proses Produksi" className="form-control form-control-user" />
                        </div>
                      </div>
                    </div>

                    <hr />
                    <div className="row">
                      <div className="col">
                        <div className="card">
                          <div className="card-body">
                            <div className="form-group">
                              <label>Item 1</label>
                              <div className="row">
                                <div className="col-xl-10 col-lg-10 col-8">
                                  <input type="text" value={scanResult1} onChange={(e) => setScanResult1(e.target.value)} placeholder="Item Code" className="form-control form-control-user" />
                                </div>
                                <div className="col-xl-2 col-lg-2 col-4 d-flex align-items-center">
                                  <button onClick={() => handleActivateScanner(1)} className="btn btn-secondary btn-sm">
                                    Scan QR
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="form-group">
                      <label>Item 2</label>
                      <div className="row">
                        <div className="col-xl-10 col-lg-10 col-8">
                          <input type="text" value={scanResult2} onChange={(e) => setScanResult2(e.target.value)} placeholder="Hasil scan QR akan muncul di sini" className="form-control form-control-user" />
                        </div>
                        <div className="col-xl-2 col-lg-2 col-4 d-flex align-items-center">
                          <button onClick={() => handleActivateScanner(2)} className="btn btn-primary btn-sm">
                            Scan QR
                          </button>
                        </div>
                      </div>
                    </div> */}

                    <div className="row">
                      <div className="col">
                        {isScannerActive && (
                          <QrScanner
                            onScan={handleScan}
                            onError={handleError}
                            style={previewStyle}
                            constraints={{
                              video: {
                                facingMode: { exact: "environment" }, // Pilih kamera belakang
                              },
                            }}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}

                    <div className="row justify-content-end mt-4">
                      <button className="btn btn-primary">Submit</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QrCodePage;
